// removed by extract-text-webpack-plugin
module.exports = {"remarkContainer":"ctxwd2lh0Ao28a0Vp6YK5","errorContainer":"_8KZjmqi-nj8rUz8nk6LF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceConfig/CopyModal.less
// module id = 1614
// module chunks = 0